import React from 'react';
import { Xmark } from '@gravity-ui/icons';
import { Button, Icon, Label, Text } from '@gravity-ui/uikit';
import i18n from '../../../../kit/i18n';
import { block } from '../../../utils';
import { readFile } from './utils';
import './FileInput.css';
const b = block('file-input');
export const FileInput = ({ name, input, spec }) => {
    var _a, _b;
    const { value, onChange } = input;
    const inputRef = React.useRef(null);
    const [fileName, setFileName] = React.useState('');
    const handleClick = React.useCallback(() => {
        var _a;
        (_a = inputRef.current) === null || _a === void 0 ? void 0 : _a.click();
    }, []);
    const handleDownload = React.useCallback(async (file) => { var _a; return await readFile(file, (_a = spec.viewSpec.fileInput) === null || _a === void 0 ? void 0 : _a.readAsMethod); }, [(_a = spec.viewSpec.fileInput) === null || _a === void 0 ? void 0 : _a.readAsMethod]);
    const handleReset = React.useCallback(() => {
        setFileName('');
        onChange('');
    }, [onChange]);
    const handleInputChange = React.useCallback(async (event) => {
        const file = event.target.files;
        if (file && file.length > 0) {
            setFileName(file[0].name);
            const data = (await handleDownload(file[0]));
            onChange(data);
        }
    }, [handleDownload, onChange]);
    const fileNameContent = React.useMemo(() => {
        if (value) {
            if (fileName) {
                return React.createElement(React.Fragment, null, fileName);
            }
            return (React.createElement(Label, { size: "m", theme: "info" }, i18n('label-data_loaded')));
        }
        return null;
    }, [fileName, value]);
    return (React.createElement("div", { className: b() },
        React.createElement(Button, { disabled: spec.viewSpec.disabled, onClick: handleClick, qa: `${name}-file-upload` }, i18n('button-upload_file')),
        React.createElement("input", { type: "file", ref: inputRef, autoComplete: "off", disabled: spec.viewSpec.disabled, onChange: handleInputChange, className: b('input'), tabIndex: -1, accept: (_b = spec.viewSpec.fileInput) === null || _b === void 0 ? void 0 : _b.accept }),
        React.createElement(Text, { className: b('file-name'), ellipsis: true, color: "secondary" }, fileNameContent),
        value ? (React.createElement(Button, { view: "flat", onClick: handleReset, disabled: spec.viewSpec.disabled, qa: `${name}-file-remove` },
            React.createElement(Icon, { data: Xmark, size: 16 }))) : null));
};
